"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouriteFoundWithoutStudy = void 0;
const wishlist_exception_1 = require("./wishlist-exception");
class FavouriteFoundWithoutStudy extends wishlist_exception_1.WishlistException {
    constructor() {
        super(`Favourite found without a study`);
        this.name = 'FavouriteFoundWithoutStudy';
    }
}
exports.FavouriteFoundWithoutStudy = FavouriteFoundWithoutStudy;
